import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
const LightTheme = React.lazy(() => import("./themes/lightTheme"));
const DarkTheme = React.lazy(() => import("./themes/darkTheme"));

const TYPE_OF_THEME = {
  LIGHT_MODE: "L",
  DARK_MODE: "D",
};
// const ThemeSelector = ({ children }) => {
//   const CHOSEN_THEME = localStorage.getItem('TYPE_OF_THEME') || TYPE_OF_THEME.DARK_MODE;
//   console.log(CHOSEN_THEME)
//   return (
//     <>
//       <React.Suspense fallback={<></>}>
//         {(CHOSEN_THEME === TYPE_OF_THEME.LIGHT_MODE) && <LightTheme />}
//         {(CHOSEN_THEME === TYPE_OF_THEME.DARK_MODE) && <DarkTheme />}
//       </React.Suspense>
//       {children}
//     </>
//   )
// }

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  // <ThemeSelector>
  <App />
  // </ThemeSelector>
);

reportWebVitals();
